import { Dropdown, DropdownItem, TDropdownElementProps } from '../../ui-toolkit';
import React, { useMemo } from 'react';
import { useOnClickLogout } from './hooks/useOnClickLogout';
import { usePrefetch } from '../../API/administration/AdminUsersAPI';

const PrefetchWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const prefetchSelf = usePrefetch('getSelfAdminUser', { ifOlderThan: 120 });
  return <div onMouseEnter={() => prefetchSelf()}>{children}</div>;
};

const getProfileMenu = ({
  handleShowProfilePage,
  onClickLogout,
}: {
  handleShowProfilePage: () => void;
  onClickLogout: () => void;
}): TDropdownElementProps[] => [
  {
    children: (
      <PrefetchWrapper>
        <DropdownItem onClick={handleShowProfilePage} displayAsGroup>
          Profile
        </DropdownItem>
      </PrefetchWrapper>
    ),
  },
  {
    children: (
      <DropdownItem onClick={onClickLogout} displayAsGroup>
        Logout
      </DropdownItem>
    ),
  },
];

export const ProfileDropdown: React.FC<{
  showDropdown: boolean;
  handleShowProfilePage: () => void;
}> = ({ showDropdown, handleShowProfilePage }) => {
  const onClickLogout = useOnClickLogout();
  const menu = useMemo(
    () => getProfileMenu({ handleShowProfilePage, onClickLogout }),
    [handleShowProfilePage, onClickLogout]
  );

  return <Dropdown show={showDropdown} position={{ anchor: 'top-right', x: 16, y: 75 }} topValue items={menu} />;
};
